import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=a43f6740&scoped=true"
import script from "./HistoryDetail.vue?vue&type=script&lang=js"
export * from "./HistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetail.vue?vue&type=style&index=0&id=a43f6740&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a43f6740",
  null
  
)

export default component.exports